import type { LandingPageData } from './../types/landing-page';

export const LandingPageFallbackData: LandingPageData = {
  id: 1,
  documentId: 'mqe76tktl6qz2y676g9m57yb',
  siteName: 'Bách Việt',
  siteDescription:
    'Công ty TNHH Sản xuất và Thương mại Hàng Cơ khí Bách Việt - Chuyên sản xuất và cung cấp các sản phẩm cơ khí chất lượng cao',
  createdAt: '2025-08-18T18:14:43.495Z',
  updatedAt: '2025-08-18T18:14:43.495Z',
  publishedAt: '2025-08-18T18:14:43.475Z',
  locale: null,
  favicon: {
    id: 14,
    name: 'favicon.png',
    alternativeText: 'An image uploaded to Strapi called favicon.png',
    caption: 'An image uploaded to Strapi called favicon.png',
    width: 512,
    height: 512,
    url: '/uploads/favicon_f31cd700ce.png',
  },
  defaultSeo: {
    id: 1,
    metaTitle: 'Bách Việt - Công ty TNHH Sản xuất và Thương mại Hàng Cơ khí',
    metaDescription:
      'Công ty TNHH Sản xuất và Thương mại Hàng Cơ khí Bách Việt - Chuyên sản xuất và cung cấp các sản phẩm cơ khí chất lượng cao',
    keywords: null,
  },
  bannerCollection: {
    id: 1,
    autoPlay: true,
    autoPlayInterval: 5000,
    showNavigation: true,
    showMouseIndicator: true,
    banners: [
      {
        order: 1,
        id: 1,
        title: 'BÁCH VIỆT',
        subtitle: 'Đơn vị chuyên gia công cơ khí chính xác hàng đầu tại Hà Nội',
        ctaText: 'giới thiệu',
        ctaLink: '/about',
        showNavigation: true,
        showMouseIndicator: true,
        overlayOpacity: 0.6,
        isActive: true,
        backgroundImage: {
          id: 17,
          documentId: 's11uke3z5f3ocg0235beqc2a',
          name: 'banner.jpg',
          alternativeText: 'An image uploaded to Strapi called banner.jpg',
          caption: 'An image uploaded to Strapi called banner.jpg',
          width: 4096,
          height: 2731,
          formats: {
            thumbnail: {
              name: 'thumbnail_banner.jpg',
              hash: 'thumbnail_banner_jpg_4f470b8c25',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 234,
              height: 156,
              size: 13.48,
              sizeInBytes: 13481,
              url: '/uploads/thumbnail_banner_jpg_4f470b8c25.jpeg',
            },
            small: {
              name: 'small_banner.jpg',
              hash: 'small_banner_jpg_4f470b8c25',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 500,
              height: 333,
              size: 43.16,
              sizeInBytes: 43161,
              url: '/uploads/small_banner_jpg_4f470b8c25.jpeg',
            },
            large: {
              name: 'large_banner.jpg',
              hash: 'large_banner_jpg_4f470b8c25',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 1000,
              height: 667,
              size: 116.42,
              sizeInBytes: 116422,
              url: '/uploads/large_banner_jpg_4f470b8c25.jpeg',
            },
            medium: {
              name: 'medium_banner.jpg',
              hash: 'medium_banner_jpg_4f470b8c25',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 750,
              height: 500,
              size: 76.13,
              sizeInBytes: 76132,
              url: '/uploads/medium_banner_jpg_4f470b8c25.jpeg',
            },
          },
          hash: 'banner_jpg_4f470b8c25',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 988.74,
          url: '/uploads/banner_jpg_4f470b8c25.jpeg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:40.954Z',
          updatedAt: '2025-08-18T18:14:40.954Z',
          publishedAt: '2025-08-18T18:14:40.954Z',
          locale: null,
        },
      },
      {
        order: 2,
        id: 2,
        title: 'CHẤT LƯỢNG CAO',
        subtitle:
          'Cam kết cung cấp các sản phẩm cơ khí chất lượng cao, đáp ứng mọi tiêu chuẩn quốc tế',
        ctaText: 'sản phẩm',
        ctaLink: '/products',
        showNavigation: true,
        showMouseIndicator: true,
        overlayOpacity: 0.6,
        isActive: true,
        backgroundImage: {
          id: 18,
          documentId: 'vgpclmnzh6ou1l29s9awsfnl',
          name: 'banner.jpg',
          alternativeText: 'An image uploaded to Strapi called banner.jpg',
          caption: 'An image uploaded to Strapi called banner.jpg',
          width: 4096,
          height: 2731,
          formats: {
            thumbnail: {
              name: 'thumbnail_banner.jpg',
              hash: 'thumbnail_banner_jpg_9df21bdc61',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 234,
              height: 156,
              size: 13.48,
              sizeInBytes: 13481,
              url: '/uploads/thumbnail_banner_jpg_9df21bdc61.jpeg',
            },
            small: {
              name: 'small_banner.jpg',
              hash: 'small_banner_jpg_9df21bdc61',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 500,
              height: 333,
              size: 43.16,
              sizeInBytes: 43161,
              url: '/uploads/small_banner_jpg_9df21bdc61.jpeg',
            },
            medium: {
              name: 'medium_banner.jpg',
              hash: 'medium_banner_jpg_9df21bdc61',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 750,
              height: 500,
              size: 76.13,
              sizeInBytes: 76132,
              url: '/uploads/medium_banner_jpg_9df21bdc61.jpeg',
            },
            large: {
              name: 'large_banner.jpg',
              hash: 'large_banner_jpg_9df21bdc61',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 1000,
              height: 667,
              size: 116.42,
              sizeInBytes: 116422,
              url: '/uploads/large_banner_jpg_9df21bdc61.jpeg',
            },
          },
          hash: 'banner_jpg_9df21bdc61',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 988.74,
          url: '/uploads/banner_jpg_9df21bdc61.jpeg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:41.130Z',
          updatedAt: '2025-08-18T18:14:41.130Z',
          publishedAt: '2025-08-18T18:14:41.130Z',
          locale: null,
        },
      },
      {
        order: 3,
        id: 3,
        title: 'DỊCH VỤ TẬN TÂM',
        subtitle:
          'Đội ngũ kỹ thuật giàu kinh nghiệm, sẵn sàng hỗ trợ và tư vấn cho khách hàng mọi lúc',
        ctaText: 'liên hệ',
        ctaLink: '/contact',
        showNavigation: true,
        showMouseIndicator: true,
        overlayOpacity: 0.6,
        isActive: true,
        backgroundImage: {
          id: 19,
          documentId: 'yib1ungnn5zbqm9vxqznchgb',
          name: 'banner.jpg',
          alternativeText: 'An image uploaded to Strapi called banner.jpg',
          caption: 'An image uploaded to Strapi called banner.jpg',
          width: 4096,
          height: 2731,
          formats: {
            thumbnail: {
              name: 'thumbnail_banner.jpg',
              hash: 'thumbnail_banner_jpg_caf8656d08',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 234,
              height: 156,
              size: 13.48,
              sizeInBytes: 13481,
              url: '/uploads/thumbnail_banner_jpg_caf8656d08.jpeg',
            },
            small: {
              name: 'small_banner.jpg',
              hash: 'small_banner_jpg_caf8656d08',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 500,
              height: 333,
              size: 43.16,
              sizeInBytes: 43161,
              url: '/uploads/small_banner_jpg_caf8656d08.jpeg',
            },
            large: {
              name: 'large_banner.jpg',
              hash: 'large_banner_jpg_caf8656d08',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 1000,
              height: 667,
              size: 116.42,
              sizeInBytes: 116422,
              url: '/uploads/large_banner_jpg_caf8656d08.jpeg',
            },
            medium: {
              name: 'medium_banner.jpg',
              hash: 'medium_banner_jpg_caf8656d08',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 750,
              height: 500,
              size: 76.13,
              sizeInBytes: 76132,
              url: '/uploads/medium_banner_jpg_caf8656d08.jpeg',
            },
          },
          hash: 'banner_jpg_caf8656d08',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 988.74,
          url: '/uploads/banner_jpg_caf8656d08.jpeg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:41.339Z',
          updatedAt: '2025-08-18T18:14:41.339Z',
          publishedAt: '2025-08-18T18:14:41.339Z',
          locale: null,
        },
      },
    ],
  },
  serviceSection: {
    id: 1,
    title: 'DỊCH VỤ',
    subtitle:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dapibus lorem ut leo condimentum posuere. Duis pretium massa a leo pellentesque varius. Nulla at turpis vitae lacus cursus sollicitudin quis ac felis. Praesent a mattis leo. Proin molestie ac odio viverra semper. Praesent ultrices tincidunt.',
    backgroundImage: {
      id: 20,
      documentId: 'hyi01jo366x3jkogefbewm2h',
      name: 'service-section-background.jpg',
      alternativeText:
        'An image uploaded to Strapi called service-section-background.jpg',
      caption:
        'An image uploaded to Strapi called service-section-background.jpg',
      width: 1920,
      height: 601,
      formats: {
        thumbnail: {
          name: 'thumbnail_service-section-background.jpg',
          hash: 'thumbnail_service_section_background_jpg_2e90037caf',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 245,
          height: 77,
          size: 0.39,
          sizeInBytes: 386,
          url: '/uploads/thumbnail_service_section_background_jpg_2e90037caf.jpeg',
        },
        large: {
          name: 'large_service-section-background.jpg',
          hash: 'large_service_section_background_jpg_2e90037caf',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 1000,
          height: 313,
          size: 9.48,
          sizeInBytes: 9476,
          url: '/uploads/large_service_section_background_jpg_2e90037caf.jpeg',
        },
        medium: {
          name: 'medium_service-section-background.jpg',
          hash: 'medium_service_section_background_jpg_2e90037caf',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 750,
          height: 235,
          size: 1.48,
          sizeInBytes: 1484,
          url: '/uploads/medium_service_section_background_jpg_2e90037caf.jpeg',
        },
        small: {
          name: 'small_service-section-background.jpg',
          hash: 'small_service_section_background_jpg_2e90037caf',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 500,
          height: 156,
          size: 0.82,
          sizeInBytes: 816,
          url: '/uploads/small_service_section_background_jpg_2e90037caf.jpeg',
        },
      },
      hash: 'service_section_background_jpg_2e90037caf',
      ext: '.jpeg',
      mime: 'image/jpeg',
      size: 123.58,
      url: '/uploads/service_section_background_jpg_2e90037caf.jpeg',
      previewUrl: null,
      provider: 'local',
      provider_metadata: null,
      folderPath: '/',
      createdAt: '2025-08-18T18:14:41.378Z',
      updatedAt: '2025-08-18T18:14:41.378Z',
      publishedAt: '2025-08-18T18:14:41.379Z',
      locale: null,
    },
    services: [
      {
        order: 1,
        id: 1,
        title: 'Đầu tư và phát triển bất động sản',
        description:
          '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dapibus lorem ut leo condimentum posuere. Duis pretium massa a leo pellentesque varius. Nulla at turpis vitae lacus cursus sollicitudin quis ac felis. Praesent a mattis leo. Proin molestie ac odio viverra semper. Praesent ultrices tincidunt.</p>',
        buttonText: 'Tìm hiểu thêm',
        buttonLink: '/services/real-estate',
        overview: null,
        isActive: null,
        image: {
          id: 21,
          documentId: 'eyze2qvi2oo969jt8ndwgx2v',
          name: 'service-1.jpg',
          alternativeText: 'An image uploaded to Strapi called service-1.jpg',
          caption: 'An image uploaded to Strapi called service-1.jpg',
          width: 4096,
          height: 2731,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-1.jpg',
              hash: 'thumbnail_service_1_jpg_dc9437d427',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 234,
              height: 156,
              size: 8.73,
              sizeInBytes: 8732,
              url: '/uploads/thumbnail_service_1_jpg_dc9437d427.jpeg',
            },
            small: {
              name: 'small_service-1.jpg',
              hash: 'small_service_1_jpg_dc9437d427',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 500,
              height: 333,
              size: 39.14,
              sizeInBytes: 39139,
              url: '/uploads/small_service_1_jpg_dc9437d427.jpeg',
            },
            medium: {
              name: 'medium_service-1.jpg',
              hash: 'medium_service_1_jpg_dc9437d427',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 750,
              height: 500,
              size: 89.17,
              sizeInBytes: 89166,
              url: '/uploads/medium_service_1_jpg_dc9437d427.jpeg',
            },
            large: {
              name: 'large_service-1.jpg',
              hash: 'large_service_1_jpg_dc9437d427',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 1000,
              height: 667,
              size: 163.42,
              sizeInBytes: 163422,
              url: '/uploads/large_service_1_jpg_dc9437d427.jpeg',
            },
          },
          hash: 'service_1_jpg_dc9437d427',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 2149.14,
          url: '/uploads/service_1_jpg_dc9437d427.jpeg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:41.667Z',
          updatedAt: '2025-08-18T18:14:41.667Z',
          publishedAt: '2025-08-18T18:14:41.667Z',
          locale: null,
        },
      },
      {
        order: 2,
        id: 2,
        title: 'Đầu tư tài chính',
        description:
          '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dapibus lorem ut leo condimentum posuere. Duis pretium massa a leo pellentesque varius. Nulla at turpis vitae lacus cursus sollicitudin quis ac felis. Praesent a mattis leo. Proin molestie ac odio viverra semper. Praesent ultrices tincidunt aliquam.</p>',
        buttonText: 'Tìm hiểu thêm',
        buttonLink: '/services/financial',
        overview: null,
        isActive: null,
        image: {
          id: 22,
          documentId: 'ka62to62h5vucpkg2z56cvfa',
          name: 'service-2.png',
          alternativeText: 'An image uploaded to Strapi called service-2.png',
          caption: 'An image uploaded to Strapi called service-2.png',
          width: 1429,
          height: 804,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-2.png',
              hash: 'thumbnail_service_2_8cf9deb782',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 138,
              size: 88.94,
              sizeInBytes: 88941,
              url: '/uploads/thumbnail_service_2_8cf9deb782.png',
            },
            small: {
              name: 'small_service-2.png',
              hash: 'small_service_2_8cf9deb782',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 281,
              size: 349.25,
              sizeInBytes: 349250,
              url: '/uploads/small_service_2_8cf9deb782.png',
            },
            medium: {
              name: 'medium_service-2.png',
              hash: 'medium_service_2_8cf9deb782',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 422,
              size: 775.72,
              sizeInBytes: 775716,
              url: '/uploads/medium_service_2_8cf9deb782.png',
            },
            large: {
              name: 'large_service-2.png',
              hash: 'large_service_2_8cf9deb782',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 563,
              size: 1371.27,
              sizeInBytes: 1371267,
              url: '/uploads/large_service_2_8cf9deb782.png',
            },
          },
          hash: 'service_2_8cf9deb782',
          ext: '.png',
          mime: 'image/png',
          size: 669.96,
          url: '/uploads/service_2_8cf9deb782.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:42.354Z',
          updatedAt: '2025-08-18T18:14:42.354Z',
          publishedAt: '2025-08-18T18:14:42.354Z',
          locale: null,
        },
      },
      {
        order: 3,
        id: 3,
        title: 'Xây dựng khu công nghiệp',
        description:
          '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dapibus lorem ut leo condimentum posuere. Duis pretium massa a leo pellentesque varius. Nulla at turpis vitae lacus cursus sollicitudin quis ac felis. Praesent a mattis leo. Proin molestie ac odio viverra semper. Praesent ultrices tincidunt.</p>',
        buttonText: 'Tìm hiểu thêm',
        buttonLink: '/services/industrial',
        overview: null,
        isActive: null,
        image: {
          id: 23,
          documentId: 'b1jbprn5up5zxphlhll448kg',
          name: 'service-3.png',
          alternativeText: 'An image uploaded to Strapi called service-3.png',
          caption: 'An image uploaded to Strapi called service-3.png',
          width: 1429,
          height: 804,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-3.png',
              hash: 'thumbnail_service_3_edd5097cce',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 138,
              size: 88.94,
              sizeInBytes: 88941,
              url: '/uploads/thumbnail_service_3_edd5097cce.png',
            },
            small: {
              name: 'small_service-3.png',
              hash: 'small_service_3_edd5097cce',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 281,
              size: 349.25,
              sizeInBytes: 349250,
              url: '/uploads/small_service_3_edd5097cce.png',
            },
            large: {
              name: 'large_service-3.png',
              hash: 'large_service_3_edd5097cce',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 563,
              size: 1371.27,
              sizeInBytes: 1371267,
              url: '/uploads/large_service_3_edd5097cce.png',
            },
            medium: {
              name: 'medium_service-3.png',
              hash: 'medium_service_3_edd5097cce',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 422,
              size: 775.72,
              sizeInBytes: 775716,
              url: '/uploads/medium_service_3_edd5097cce.png',
            },
          },
          hash: 'service_3_edd5097cce',
          ext: '.png',
          mime: 'image/png',
          size: 669.96,
          url: '/uploads/service_3_edd5097cce.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.043Z',
          updatedAt: '2025-08-18T18:14:43.043Z',
          publishedAt: '2025-08-18T18:14:43.043Z',
          locale: null,
        },
      },
    ],
    cta: {
      id: 1,
      title: 'Tìm hiểu thêm',
      description: 'Khám phá các dịch vụ của chúng tôi',
      buttonText: 'TÌM HIỂU THÊM',
      buttonLink: '/services',
    },
  },
  aboutSection: {
    id: 1,
    title: 'VỀ BÁCH VIỆT',
    content:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dapibus lorem ut leo condimentum posuere. Duis pretium massa a leo pellentesque varius. Nulla at turpis vitae lacus cursus sollicitudin quis ac felis. Praesent a mattis leo. Proin molestie ac odio viverra semper. Praesent ultrices tincidunt aliquam.</p><p>Duis quis dolor finibus, varius lorem et, porttitor nulla. Aenean a finibus ligula.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dapibus lorem ut leo condimentum posuere. Duis pretium massa a leo pellentesque varius. Nulla at turpis vitae lacus cursus sollicitudin quis ac felis. Praesent a mattis leo. Proin molestie ac odio viverra semper. Praesent ultrices tincidunt aliquam.</p><p>Duis quis dolor finibus, varius lorem et, porttitor nulla. Aenean a finibus ligula.</p>',
    buttonText: 'GIỚI THIỆU',
    buttonLink: '/about',
    image: {
      id: 24,
      documentId: 'wgkgli2zxcymtricii1r6sw1',
      name: 'about-section-image.png',
      alternativeText:
        'An image uploaded to Strapi called about-section-image.png',
      caption: 'An image uploaded to Strapi called about-section-image.png',
      width: 700,
      height: 550,
      formats: {
        thumbnail: {
          name: 'thumbnail_about-section-image.png',
          hash: 'thumbnail_about_section_image_93e0c19636',
          ext: '.png',
          mime: 'image/png',
          path: null,
          width: 199,
          height: 156,
          size: 72.51,
          sizeInBytes: 72507,
          url: '/uploads/thumbnail_about_section_image_93e0c19636.png',
        },
        small: {
          name: 'small_about-section-image.png',
          hash: 'small_about_section_image_93e0c19636',
          ext: '.png',
          mime: 'image/png',
          path: null,
          width: 500,
          height: 393,
          size: 424.19,
          sizeInBytes: 424193,
          url: '/uploads/small_about_section_image_93e0c19636.png',
        },
      },
      hash: 'about_section_image_93e0c19636',
      ext: '.png',
      mime: 'image/png',
      size: 199.13,
      url: '/uploads/about_section_image_93e0c19636.png',
      previewUrl: null,
      provider: 'local',
      provider_metadata: null,
      folderPath: '/',
      createdAt: '2025-08-18T18:14:43.396Z',
      updatedAt: '2025-08-18T18:14:43.396Z',
      publishedAt: '2025-08-18T18:14:43.396Z',
      locale: null,
    },
  },
  partnersSection: {
    id: 1,
    title: 'ĐỐI TÁC',
    subtitle: 'Những đối tác tin cậy đã đồng hành cùng chúng tôi',
    autoPlay: true,
    autoPlayInterval: 5000,
    partners: [
      {
        order: 1,
        id: 1,
        name: 'Logoipsum',
        website: 'https://logoipsum.com',
        isActive: true,
        logo: {
          id: 25,
          documentId: 'o4e8rjnyh2d4re7vei46hi3f',
          name: 'partners/logoipsum-1.svg',
          alternativeText:
            'An image uploaded to Strapi called partners/logoipsum-1.svg',
          caption:
            'An image uploaded to Strapi called partners/logoipsum-1.svg',
          width: 195,
          height: 56,
          formats: null,
          hash: 'logoipsum_1_afa42ed5ea',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 5.19,
          url: '/uploads/logoipsum_1_afa42ed5ea.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.418Z',
          updatedAt: '2025-08-18T18:14:43.418Z',
          publishedAt: '2025-08-18T18:14:43.418Z',
          locale: null,
        },
      },
      {
        order: 2,
        id: 2,
        name: 'Logoipsum',
        website: 'https://logoipsum.com',
        isActive: true,
        logo: {
          id: 26,
          documentId: 'zpd6yxai8h8pgzsq04y6ckgs',
          name: 'partners/logoipsum-2.svg',
          alternativeText:
            'An image uploaded to Strapi called partners/logoipsum-2.svg',
          caption:
            'An image uploaded to Strapi called partners/logoipsum-2.svg',
          width: 194,
          height: 56,
          formats: null,
          hash: 'logoipsum_2_2ce56bffbb',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 4.49,
          url: '/uploads/logoipsum_2_2ce56bffbb.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.427Z',
          updatedAt: '2025-08-18T18:14:43.427Z',
          publishedAt: '2025-08-18T18:14:43.427Z',
          locale: null,
        },
      },
      {
        order: 3,
        id: 3,
        name: 'Logoipsum',
        website: 'https://logoipsum.com',
        isActive: true,
        logo: {
          id: 27,
          documentId: 'ss6wcqbdj6v5ao2jimk1ru47',
          name: 'partners/logoipsum-3.svg',
          alternativeText:
            'An image uploaded to Strapi called partners/logoipsum-3.svg',
          caption:
            'An image uploaded to Strapi called partners/logoipsum-3.svg',
          width: 192,
          height: 56,
          formats: null,
          hash: 'logoipsum_3_ff0e7353e3',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 5.41,
          url: '/uploads/logoipsum_3_ff0e7353e3.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.437Z',
          updatedAt: '2025-08-18T18:14:43.437Z',
          publishedAt: '2025-08-18T18:14:43.437Z',
          locale: null,
        },
      },
      {
        order: 4,
        id: 4,
        name: 'Logoipsum',
        website: 'https://logoipsum.com',
        isActive: true,
        logo: {
          id: 28,
          documentId: 'lfaa0475pbr6yv4hcczhaqhr',
          name: 'partners/logoipsum-1.svg',
          alternativeText:
            'An image uploaded to Strapi called partners/logoipsum-1.svg',
          caption:
            'An image uploaded to Strapi called partners/logoipsum-1.svg',
          width: 195,
          height: 56,
          formats: null,
          hash: 'logoipsum_1_c69730b456',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 5.19,
          url: '/uploads/logoipsum_1_c69730b456.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.446Z',
          updatedAt: '2025-08-18T18:14:43.446Z',
          publishedAt: '2025-08-18T18:14:43.446Z',
          locale: null,
        },
      },
      {
        order: 5,
        id: 5,
        name: 'Logoipsum',
        website: 'https://logoipsum.com',
        isActive: true,
        logo: {
          id: 29,
          documentId: 'c2cxg89n07s2khqdegb1jdq1',
          name: 'partners/logoipsum-2.svg',
          alternativeText:
            'An image uploaded to Strapi called partners/logoipsum-2.svg',
          caption:
            'An image uploaded to Strapi called partners/logoipsum-2.svg',
          width: 194,
          height: 56,
          formats: null,
          hash: 'logoipsum_2_12d6248ca5',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 4.49,
          url: '/uploads/logoipsum_2_12d6248ca5.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.454Z',
          updatedAt: '2025-08-18T18:14:43.454Z',
          publishedAt: '2025-08-18T18:14:43.454Z',
          locale: null,
        },
      },
      {
        order: 6,
        id: 6,
        name: 'Logoipsum',
        website: 'https://logoipsum.com',
        isActive: true,
        logo: {
          id: 30,
          documentId: 'i4frffzpd0km2jnglft89l4j',
          name: 'partners/logoipsum-3.svg',
          alternativeText:
            'An image uploaded to Strapi called partners/logoipsum-3.svg',
          caption:
            'An image uploaded to Strapi called partners/logoipsum-3.svg',
          width: 192,
          height: 56,
          formats: null,
          hash: 'logoipsum_3_9c04c6e705',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 5.41,
          url: '/uploads/logoipsum_3_9c04c6e705.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.463Z',
          updatedAt: '2025-08-18T18:14:43.463Z',
          publishedAt: '2025-08-18T18:14:43.463Z',
          locale: null,
        },
      },
      {
        order: 7,
        id: 7,
        name: 'Logoipsum',
        website: 'https://logoipsum.com',
        isActive: true,
        logo: {
          id: 31,
          documentId: 'ng6xeucd4tikjjn5v6xczool',
          name: 'partners/logoipsum-1.svg',
          alternativeText:
            'An image uploaded to Strapi called partners/logoipsum-1.svg',
          caption:
            'An image uploaded to Strapi called partners/logoipsum-1.svg',
          width: 195,
          height: 56,
          formats: null,
          hash: 'logoipsum_1_3bd6ca4634',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 5.19,
          url: '/uploads/logoipsum_1_3bd6ca4634.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.472Z',
          updatedAt: '2025-08-18T18:14:43.472Z',
          publishedAt: '2025-08-18T18:14:43.472Z',
          locale: null,
        },
      },
    ],
  },
  featuredProjectsSection: {
    id: 1,
    title: 'DỰ ÁN TIÊU BIỂU',
    subtitle: 'Những dự án nổi bật mà chúng tôi đã thực hiện thành công',
    projects: [
      {
        id: 2,
        documentId: 'ja1wzytxbe4im9rn80k8wchf',
        title: 'Dự án gia công CNC chính xác',
        description:
          'Dự án gia công các chi tiết cơ khí chính xác cho ngành công nghiệp ô tô',
        order: 1,
        isActive: true,
        isFeatured: true,
        createdAt: '2025-08-18T18:14:36.277Z',
        updatedAt: '2025-08-18T18:14:36.277Z',
        publishedAt: '2025-08-18T18:14:36.278Z',
        locale: null,
        image: {
          id: 1,
          documentId: 'mt03zkuxs43jlcfu0g1sxmcu',
          name: 'service-2.png',
          alternativeText: 'An image uploaded to Strapi called service-2.png',
          caption: 'An image uploaded to Strapi called service-2.png',
          width: 1429,
          height: 804,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-2.png',
              hash: 'thumbnail_service_2_bf727f2bb4',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 138,
              size: 88.94,
              sizeInBytes: 88941,
              url: '/uploads/thumbnail_service_2_bf727f2bb4.png',
            },
            small: {
              name: 'small_service-2.png',
              hash: 'small_service_2_bf727f2bb4',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 281,
              size: 349.25,
              sizeInBytes: 349250,
              url: '/uploads/small_service_2_bf727f2bb4.png',
            },
            medium: {
              name: 'medium_service-2.png',
              hash: 'medium_service_2_bf727f2bb4',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 422,
              size: 775.72,
              sizeInBytes: 775716,
              url: '/uploads/medium_service_2_bf727f2bb4.png',
            },
            large: {
              name: 'large_service-2.png',
              hash: 'large_service_2_bf727f2bb4',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 563,
              size: 1371.27,
              sizeInBytes: 1371267,
              url: '/uploads/large_service_2_bf727f2bb4.png',
            },
          },
          hash: 'service_2_bf727f2bb4',
          ext: '.png',
          mime: 'image/png',
          size: 669.96,
          url: '/uploads/service_2_bf727f2bb4.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:36.273Z',
          updatedAt: '2025-08-18T18:14:36.273Z',
          publishedAt: '2025-08-18T18:14:36.274Z',
          locale: null,
        },
      },
      {
        id: 4,
        documentId: 'gxwab96bezjeichk88xdmw17',
        title: 'Sản xuất linh kiện máy móc',
        description:
          'Sản xuất hàng loạt các linh kiện máy móc theo tiêu chuẩn quốc tế',
        order: 2,
        isActive: true,
        isFeatured: true,
        createdAt: '2025-08-18T18:14:36.569Z',
        updatedAt: '2025-08-18T18:14:36.569Z',
        publishedAt: '2025-08-18T18:14:36.570Z',
        locale: null,
        image: {
          id: 2,
          documentId: 'aquqbt7uu4n4hzksp8fhykrp',
          name: 'service-1.jpg',
          alternativeText: 'An image uploaded to Strapi called service-1.jpg',
          caption: 'An image uploaded to Strapi called service-1.jpg',
          width: 4096,
          height: 2731,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-1.jpg',
              hash: 'thumbnail_service_1_jpg_c10a83b626',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 234,
              height: 156,
              size: 8.73,
              sizeInBytes: 8732,
              url: '/uploads/thumbnail_service_1_jpg_c10a83b626.jpeg',
            },
            small: {
              name: 'small_service-1.jpg',
              hash: 'small_service_1_jpg_c10a83b626',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 500,
              height: 333,
              size: 39.14,
              sizeInBytes: 39139,
              url: '/uploads/small_service_1_jpg_c10a83b626.jpeg',
            },
            medium: {
              name: 'medium_service-1.jpg',
              hash: 'medium_service_1_jpg_c10a83b626',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 750,
              height: 500,
              size: 89.17,
              sizeInBytes: 89166,
              url: '/uploads/medium_service_1_jpg_c10a83b626.jpeg',
            },
            large: {
              name: 'large_service-1.jpg',
              hash: 'large_service_1_jpg_c10a83b626',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 1000,
              height: 667,
              size: 163.42,
              sizeInBytes: 163422,
              url: '/uploads/large_service_1_jpg_c10a83b626.jpeg',
            },
          },
          hash: 'service_1_jpg_c10a83b626',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 2149.14,
          url: '/uploads/service_1_jpg_c10a83b626.jpeg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:36.566Z',
          updatedAt: '2025-08-18T18:14:36.566Z',
          publishedAt: '2025-08-18T18:14:36.566Z',
          locale: null,
        },
      },
      {
        id: 6,
        documentId: 'tvmrmw1a4v7ewcztlsexwhqw',
        title: 'Thiết kế và chế tạo máy đặc biệt',
        description:
          'Thiết kế và chế tạo máy móc đặc biệt theo yêu cầu của khách hàng',
        order: 3,
        isActive: true,
        isFeatured: true,
        createdAt: '2025-08-18T18:14:37.246Z',
        updatedAt: '2025-08-18T18:14:37.246Z',
        publishedAt: '2025-08-18T18:14:37.247Z',
        locale: null,
        image: {
          id: 3,
          documentId: 'rhgg6l0bammlrcueiqlkr96e',
          name: 'service-2.png',
          alternativeText: 'An image uploaded to Strapi called service-2.png',
          caption: 'An image uploaded to Strapi called service-2.png',
          width: 1429,
          height: 804,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-2.png',
              hash: 'thumbnail_service_2_fa22e029f2',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 138,
              size: 88.94,
              sizeInBytes: 88941,
              url: '/uploads/thumbnail_service_2_fa22e029f2.png',
            },
            small: {
              name: 'small_service-2.png',
              hash: 'small_service_2_fa22e029f2',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 281,
              size: 349.25,
              sizeInBytes: 349250,
              url: '/uploads/small_service_2_fa22e029f2.png',
            },
            large: {
              name: 'large_service-2.png',
              hash: 'large_service_2_fa22e029f2',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 563,
              size: 1371.27,
              sizeInBytes: 1371267,
              url: '/uploads/large_service_2_fa22e029f2.png',
            },
            medium: {
              name: 'medium_service-2.png',
              hash: 'medium_service_2_fa22e029f2',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 422,
              size: 775.72,
              sizeInBytes: 775716,
              url: '/uploads/medium_service_2_fa22e029f2.png',
            },
          },
          hash: 'service_2_fa22e029f2',
          ext: '.png',
          mime: 'image/png',
          size: 669.96,
          url: '/uploads/service_2_fa22e029f2.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:37.244Z',
          updatedAt: '2025-08-18T18:14:37.244Z',
          publishedAt: '2025-08-18T18:14:37.244Z',
          locale: null,
        },
      },
      {
        id: 8,
        documentId: 'kaznb4m8pmo967ukotsgins9',
        title: 'Bảo trì và nâng cấp hệ thống',
        description: 'Dịch vụ bảo trì và nâng cấp hệ thống máy móc công nghiệp',
        order: 4,
        isActive: true,
        isFeatured: true,
        createdAt: '2025-08-18T18:14:37.912Z',
        updatedAt: '2025-08-18T18:14:37.912Z',
        publishedAt: '2025-08-18T18:14:37.913Z',
        locale: null,
        image: {
          id: 4,
          documentId: 'gm0i85vtvck55ftmyrxj777u',
          name: 'service-3.png',
          alternativeText: 'An image uploaded to Strapi called service-3.png',
          caption: 'An image uploaded to Strapi called service-3.png',
          width: 1429,
          height: 804,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-3.png',
              hash: 'thumbnail_service_3_5139a03fd1',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 138,
              size: 88.94,
              sizeInBytes: 88941,
              url: '/uploads/thumbnail_service_3_5139a03fd1.png',
            },
            small: {
              name: 'small_service-3.png',
              hash: 'small_service_3_5139a03fd1',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 281,
              size: 349.25,
              sizeInBytes: 349250,
              url: '/uploads/small_service_3_5139a03fd1.png',
            },
            large: {
              name: 'large_service-3.png',
              hash: 'large_service_3_5139a03fd1',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 563,
              size: 1371.27,
              sizeInBytes: 1371267,
              url: '/uploads/large_service_3_5139a03fd1.png',
            },
            medium: {
              name: 'medium_service-3.png',
              hash: 'medium_service_3_5139a03fd1',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 422,
              size: 775.72,
              sizeInBytes: 775716,
              url: '/uploads/medium_service_3_5139a03fd1.png',
            },
          },
          hash: 'service_3_5139a03fd1',
          ext: '.png',
          mime: 'image/png',
          size: 669.96,
          url: '/uploads/service_3_5139a03fd1.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:37.909Z',
          updatedAt: '2025-08-18T18:14:37.909Z',
          publishedAt: '2025-08-18T18:14:37.909Z',
          locale: null,
        },
      },
      {
        id: 10,
        documentId: 'hew8rlkvp8ql0bw2af2a0wvx',
        title: 'Sản xuất linh kiện máy móc',
        description:
          'Sản xuất hàng loạt các linh kiện máy móc theo tiêu chuẩn quốc tế',
        order: 5,
        isActive: true,
        isFeatured: true,
        createdAt: '2025-08-18T18:14:38.197Z',
        updatedAt: '2025-08-18T18:14:38.197Z',
        publishedAt: '2025-08-18T18:14:38.198Z',
        locale: null,
        image: {
          id: 5,
          documentId: 'l0fyf7sdeejqem3oxtwsg4sh',
          name: 'service-1.jpg',
          alternativeText: 'An image uploaded to Strapi called service-1.jpg',
          caption: 'An image uploaded to Strapi called service-1.jpg',
          width: 4096,
          height: 2731,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-1.jpg',
              hash: 'thumbnail_service_1_jpg_6ccb0aa593',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 234,
              height: 156,
              size: 8.73,
              sizeInBytes: 8732,
              url: '/uploads/thumbnail_service_1_jpg_6ccb0aa593.jpeg',
            },
            small: {
              name: 'small_service-1.jpg',
              hash: 'small_service_1_jpg_6ccb0aa593',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 500,
              height: 333,
              size: 39.14,
              sizeInBytes: 39139,
              url: '/uploads/small_service_1_jpg_6ccb0aa593.jpeg',
            },
            large: {
              name: 'large_service-1.jpg',
              hash: 'large_service_1_jpg_6ccb0aa593',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 1000,
              height: 667,
              size: 163.42,
              sizeInBytes: 163422,
              url: '/uploads/large_service_1_jpg_6ccb0aa593.jpeg',
            },
            medium: {
              name: 'medium_service-1.jpg',
              hash: 'medium_service_1_jpg_6ccb0aa593',
              ext: '.jpeg',
              mime: 'image/jpeg',
              path: null,
              width: 750,
              height: 500,
              size: 89.17,
              sizeInBytes: 89166,
              url: '/uploads/medium_service_1_jpg_6ccb0aa593.jpeg',
            },
          },
          hash: 'service_1_jpg_6ccb0aa593',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 2149.14,
          url: '/uploads/service_1_jpg_6ccb0aa593.jpeg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:38.195Z',
          updatedAt: '2025-08-18T18:14:38.195Z',
          publishedAt: '2025-08-18T18:14:38.195Z',
          locale: null,
        },
      },
      {
        id: 12,
        documentId: 'qejzdzbya881dcgxzj4j1vea',
        title: 'Thiết kế và chế tạo máy đặc biệt',
        description:
          'Thiết kế và chế tạo máy móc đặc biệt theo yêu cầu của khách hàng',
        order: 6,
        isActive: true,
        isFeatured: true,
        createdAt: '2025-08-18T18:14:38.871Z',
        updatedAt: '2025-08-18T18:14:38.871Z',
        publishedAt: '2025-08-18T18:14:38.872Z',
        locale: null,
        image: {
          id: 6,
          documentId: 'i4d03qjb1te6hd0lm0cpi46p',
          name: 'service-2.png',
          alternativeText: 'An image uploaded to Strapi called service-2.png',
          caption: 'An image uploaded to Strapi called service-2.png',
          width: 1429,
          height: 804,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-2.png',
              hash: 'thumbnail_service_2_3202801919',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 138,
              size: 88.94,
              sizeInBytes: 88941,
              url: '/uploads/thumbnail_service_2_3202801919.png',
            },
            small: {
              name: 'small_service-2.png',
              hash: 'small_service_2_3202801919',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 281,
              size: 349.25,
              sizeInBytes: 349250,
              url: '/uploads/small_service_2_3202801919.png',
            },
            medium: {
              name: 'medium_service-2.png',
              hash: 'medium_service_2_3202801919',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 422,
              size: 775.72,
              sizeInBytes: 775716,
              url: '/uploads/medium_service_2_3202801919.png',
            },
            large: {
              name: 'large_service-2.png',
              hash: 'large_service_2_3202801919',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 563,
              size: 1371.27,
              sizeInBytes: 1371267,
              url: '/uploads/large_service_2_3202801919.png',
            },
          },
          hash: 'service_2_3202801919',
          ext: '.png',
          mime: 'image/png',
          size: 669.96,
          url: '/uploads/service_2_3202801919.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:38.868Z',
          updatedAt: '2025-08-18T18:14:38.868Z',
          publishedAt: '2025-08-18T18:14:38.868Z',
          locale: null,
        },
      },
      {
        id: 14,
        documentId: 'hauodjnd7jbhao7h03pfjv27',
        title: 'Bảo trì và nâng cấp hệ thống',
        description: 'Dịch vụ bảo trì và nâng cấp hệ thống máy móc công nghiệp',
        order: 7,
        isActive: true,
        isFeatured: true,
        createdAt: '2025-08-18T18:14:39.639Z',
        updatedAt: '2025-08-18T18:14:39.639Z',
        publishedAt: '2025-08-18T18:14:39.648Z',
        locale: null,
        image: {
          id: 7,
          documentId: 'nf812htyfmr0em0mq75n1z8l',
          name: 'service-3.png',
          alternativeText: 'An image uploaded to Strapi called service-3.png',
          caption: 'An image uploaded to Strapi called service-3.png',
          width: 1429,
          height: 804,
          formats: {
            thumbnail: {
              name: 'thumbnail_service-3.png',
              hash: 'thumbnail_service_3_09f073b114',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 138,
              size: 88.94,
              sizeInBytes: 88941,
              url: '/uploads/thumbnail_service_3_09f073b114.png',
            },
            small: {
              name: 'small_service-3.png',
              hash: 'small_service_3_09f073b114',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 281,
              size: 349.25,
              sizeInBytes: 349250,
              url: '/uploads/small_service_3_09f073b114.png',
            },
            medium: {
              name: 'medium_service-3.png',
              hash: 'medium_service_3_09f073b114',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 422,
              size: 775.72,
              sizeInBytes: 775716,
              url: '/uploads/medium_service_3_09f073b114.png',
            },
            large: {
              name: 'large_service-3.png',
              hash: 'large_service_3_09f073b114',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 563,
              size: 1371.27,
              sizeInBytes: 1371267,
              url: '/uploads/large_service_3_09f073b114.png',
            },
          },
          hash: 'service_3_09f073b114',
          ext: '.png',
          mime: 'image/png',
          size: 669.96,
          url: '/uploads/service_3_09f073b114.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:39.629Z',
          updatedAt: '2025-08-18T18:14:39.629Z',
          publishedAt: '2025-08-18T18:14:39.629Z',
          locale: null,
        },
      },
    ],
  },
  featuredNewsSection: {
    id: 1,
    title: 'TIN TỨC',
    subtitle: 'Cập nhật những tin tức mới nhất về Bách Việt và ngành cơ khí',
    viewMoreText: 'Xem thêm',
    viewMoreLink: '/news',
    articles: [
      {
        id: 2,
        documentId: 'piqj7b7ly7yyqe5ixml7ati5',
        title: 'An cư, đầu tư vững chắc tại shophouse Bách Việt Hà Nội',
        slug: 'an-cu-dau-tu-vung-chac-tai-shophouse-bach-viet-ha-noi-1',
        excerpt:
          'Dự án shophouse Bách Việt Hà Nội mang đến cơ hội đầu tư và an cư lý tưởng với vị trí đắc địa và chính sách ưu đãi hấp dẫn.',
        content:
          '<h2>Shophouse Bách Việt Hà Nội - Lựa chọn đầu tư thông minh</h2><p>Dự án shophouse Bách Việt Hà Nội được thiết kế với tiêu chuẩn cao cấp, mang đến cơ hội đầu tư và an cư lý tưởng cho các nhà đầu tư thông minh. Với vị trí đắc địa tại trung tâm thành phố, dự án hứa hẹn mang lại lợi nhuận cao và giá trị tăng trưởng bền vững.</p><h3>Điểm nổi bật của dự án</h3><ul><li><strong>Vị trí đắc địa:</strong> Nằm tại khu vực trung tâm, thuận tiện giao thông</li><li><strong>Thiết kế hiện đại:</strong> Kiến trúc tối ưu, phù hợp với xu hướng thị trường</li><li><strong>Tiện ích đầy đủ:</strong> Hệ thống tiện ích đồng bộ, đáp ứng mọi nhu cầu</li><li><strong>Tiềm năng tăng trưởng:</strong> Khu vực có tiềm năng phát triển mạnh mẽ</li></ul><h3>Chính sách ưu đãi hấp dẫn</h3><p>Bách Việt áp dụng nhiều chính sách ưu đãi đặc biệt cho khách hàng đầu tư, bao gồm:</p><ul><li>Hỗ trợ vay vốn với lãi suất ưu đãi</li><li>Chính sách ân hạn nợ gốc linh hoạt</li><li>Bảo hành chất lượng dài hạn</li><li>Dịch vụ quản lý chuyên nghiệp</li></ul><p>Đây là cơ hội đầu tư không thể bỏ qua cho những ai đang tìm kiếm một sản phẩm bất động sản chất lượng cao với tiềm năng sinh lời lớn.</p>',
        author: 'Bách Việt',
        publishedDate: '2024-11-18T00:00:00.000Z',
        readingTime: 5,
        featured: true,
        tags: ['shophouse', 'ha-noi', 'bach-viet'],
        createdAt: '2025-08-18T18:14:39.945Z',
        updatedAt: '2025-08-18T18:14:39.945Z',
        publishedAt: '2025-08-18T18:14:39.947Z',
        locale: null,
        featuredImage: {
          id: 8,
          documentId: 'v5tv3m9a3m02qeoi8rpqsw0v',
          name: 'default-image.png',
          alternativeText:
            'An image uploaded to Strapi called default-image.png',
          caption: 'An image uploaded to Strapi called default-image.png',
          width: 1208,
          height: 715,
          formats: {
            thumbnail: {
              name: 'thumbnail_default-image.png',
              hash: 'thumbnail_default_image_05912ebe4b',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 145,
              size: 21.22,
              sizeInBytes: 21219,
              url: '/uploads/thumbnail_default_image_05912ebe4b.png',
            },
            small: {
              name: 'small_default-image.png',
              hash: 'small_default_image_05912ebe4b',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 296,
              size: 75.54,
              sizeInBytes: 75538,
              url: '/uploads/small_default_image_05912ebe4b.png',
            },
            medium: {
              name: 'medium_default-image.png',
              hash: 'medium_default_image_05912ebe4b',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 444,
              size: 174.97,
              sizeInBytes: 174967,
              url: '/uploads/medium_default_image_05912ebe4b.png',
            },
            large: {
              name: 'large_default-image.png',
              hash: 'large_default_image_05912ebe4b',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 592,
              size: 328.03,
              sizeInBytes: 328028,
              url: '/uploads/large_default_image_05912ebe4b.png',
            },
          },
          hash: 'default_image_05912ebe4b',
          ext: '.png',
          mime: 'image/png',
          size: 81.73,
          url: '/uploads/default_image_05912ebe4b.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:39.943Z',
          updatedAt: '2025-08-18T18:14:39.943Z',
          publishedAt: '2025-08-18T18:14:39.943Z',
          locale: null,
        },
      },
      {
        id: 4,
        documentId: 'znacs4ktt1td0k4g6n4ri18b',
        title: 'Chính sách ân hạn nợ gốc vô thời hạn',
        slug: 'chinh-sach-an-han-no-goc-vo-thoi-han-1',
        excerpt:
          'Bách Việt triển khai chính sách ân hạn nợ gốc vô thời hạn, mang đến giải pháp tài chính linh hoạt cho khách hàng.',
        content:
          '<h2>Chính sách ân hạn nợ gốc - Giải pháp tài chính linh hoạt</h2><p>Bách Việt triển khai chính sách ân hạn nợ gốc vô thời hạn, mang đến giải pháp tài chính linh hoạt và hỗ trợ tối đa cho khách hàng trong quá trình sở hữu bất động sản.</p><h3>Đặc điểm của chính sách</h3><ul><li><strong>Ân hạn vô thời hạn:</strong> Không giới hạn thời gian ân hạn nợ gốc</li><li><strong>Linh hoạt trong thanh toán:</strong> Khách hàng có thể lựa chọn thời điểm trả nợ gốc</li><li><strong>Giảm áp lực tài chính:</strong> Chỉ cần thanh toán lãi suất trong thời gian ân hạn</li><li><strong>Phù hợp mọi đối tượng:</strong> Áp dụng cho cả khách hàng cá nhân và doanh nghiệp</li></ul><h3>Lợi ích của chính sách</h3><p>Chính sách này mang lại nhiều lợi ích thiết thực:</p><ul><li>Giúp khách hàng dễ dàng sở hữu bất động sản</li><li>Giảm áp lực tài chính trong thời gian đầu</li><li>Tạo điều kiện thuận lợi cho việc đầu tư và kinh doanh</li><li>Thể hiện cam kết hỗ trợ khách hàng của Bách Việt</li></ul><p>Với chính sách ân hạn nợ gốc vô thời hạn, Bách Việt mong muốn đồng hành cùng khách hàng trên con đường sở hữu bất động sản mơ ước.</p>',
        author: 'Bách Việt',
        publishedDate: '2024-11-18T00:00:00.000Z',
        readingTime: 4,
        featured: true,
        tags: ['an-han-no', 'bach-viet'],
        createdAt: '2025-08-18T18:14:40.063Z',
        updatedAt: '2025-08-18T18:14:40.063Z',
        publishedAt: '2025-08-18T18:14:40.065Z',
        locale: null,
        featuredImage: {
          id: 9,
          documentId: 'gqu08rjxfwhqaixm8plgnogk',
          name: 'default-image.png',
          alternativeText:
            'An image uploaded to Strapi called default-image.png',
          caption: 'An image uploaded to Strapi called default-image.png',
          width: 1208,
          height: 715,
          formats: {
            thumbnail: {
              name: 'thumbnail_default-image.png',
              hash: 'thumbnail_default_image_05097ddb64',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 145,
              size: 21.22,
              sizeInBytes: 21219,
              url: '/uploads/thumbnail_default_image_05097ddb64.png',
            },
            small: {
              name: 'small_default-image.png',
              hash: 'small_default_image_05097ddb64',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 296,
              size: 75.54,
              sizeInBytes: 75538,
              url: '/uploads/small_default_image_05097ddb64.png',
            },
            medium: {
              name: 'medium_default-image.png',
              hash: 'medium_default_image_05097ddb64',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 444,
              size: 174.97,
              sizeInBytes: 174967,
              url: '/uploads/medium_default_image_05097ddb64.png',
            },
            large: {
              name: 'large_default-image.png',
              hash: 'large_default_image_05097ddb64',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 592,
              size: 328.03,
              sizeInBytes: 328028,
              url: '/uploads/large_default_image_05097ddb64.png',
            },
          },
          hash: 'default_image_05097ddb64',
          ext: '.png',
          mime: 'image/png',
          size: 81.73,
          url: '/uploads/default_image_05097ddb64.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:40.061Z',
          updatedAt: '2025-08-18T18:14:40.061Z',
          publishedAt: '2025-08-18T18:14:40.061Z',
          locale: null,
        },
      },
      {
        id: 6,
        documentId: 'xedtdj0l9faey8nrfvjo6nri',
        title: 'Hạ tầng giao thông đồng bộ kích cầu thị trường BĐS Phú Yên',
        slug: 'ha-tang-giao-thong-dong-bo-kich-cau-thi-truong-bds-phu-yen-1',
        excerpt:
          'Việc phát triển hạ tầng giao thông đồng bộ tại Phú Yên đang tạo ra cơ hội mới cho thị trường bất động sản khu vực này.',
        content:
          '<h2>Phát triển hạ tầng giao thông - Động lực tăng trưởng BĐS Phú Yên</h2><p>Việc đầu tư và phát triển hạ tầng giao thông đồng bộ tại Phú Yên đang tạo ra những cơ hội mới cho thị trường bất động sản khu vực này. Các dự án giao thông trọng điểm đang được triển khai mạnh mẽ.</p><h3>Các dự án hạ tầng trọng điểm</h3><ul><li><strong>Cầu Vàm Cống:</strong> Kết nối giao thông quan trọng trong khu vực</li><li><strong>Đường cao tốc:</strong> Hệ thống đường cao tốc hiện đại</li><li><strong>Cảng biển:</strong> Phát triển cảng biển quốc tế</li><li><strong>Sân bay:</strong> Mở rộng và nâng cấp sân bay Tuy Hòa</li></ul><h3>Tác động đến thị trường BĐS</h3><p>Sự phát triển hạ tầng giao thông mang lại nhiều tác động tích cực:</p><ul><li>Tăng tính kết nối và thuận tiện di chuyển</li><li>Thúc đẩy phát triển kinh tế địa phương</li><li>Tạo cơ hội đầu tư bất động sản mới</li><li>Nâng cao giá trị bất động sản trong khu vực</li></ul><h3>Cơ hội đầu tư</h3><p>Với sự phát triển hạ tầng mạnh mẽ, Phú Yên đang trở thành điểm đến đầu tư hấp dẫn:</p><ul><li>Giá bất động sản còn thấp so với tiềm năng</li><li>Chính sách ưu đãi đầu tư của địa phương</li><li>Tiềm năng phát triển du lịch và thương mại</li><li>Môi trường sống trong lành, thiên nhiên đẹp</li></ul><p>Bách Việt đang theo dõi sát sao sự phát triển của thị trường BĐS Phú Yên và sẵn sàng đưa ra những sản phẩm phù hợp với nhu cầu thị trường.</p>',
        author: 'Bách Việt',
        publishedDate: '2024-11-18T00:00:00.000Z',
        readingTime: 6,
        featured: true,
        tags: ['giao-thong', 'phu-yen'],
        createdAt: '2025-08-18T18:14:40.178Z',
        updatedAt: '2025-08-18T18:14:40.178Z',
        publishedAt: '2025-08-18T18:14:40.179Z',
        locale: null,
        featuredImage: {
          id: 10,
          documentId: 'owy7t1497q7g3w858einshf8',
          name: 'default-image.png',
          alternativeText:
            'An image uploaded to Strapi called default-image.png',
          caption: 'An image uploaded to Strapi called default-image.png',
          width: 1208,
          height: 715,
          formats: {
            thumbnail: {
              name: 'thumbnail_default-image.png',
              hash: 'thumbnail_default_image_a5eaa20955',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 145,
              size: 21.22,
              sizeInBytes: 21219,
              url: '/uploads/thumbnail_default_image_a5eaa20955.png',
            },
            small: {
              name: 'small_default-image.png',
              hash: 'small_default_image_a5eaa20955',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 296,
              size: 75.54,
              sizeInBytes: 75538,
              url: '/uploads/small_default_image_a5eaa20955.png',
            },
            large: {
              name: 'large_default-image.png',
              hash: 'large_default_image_a5eaa20955',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 592,
              size: 328.03,
              sizeInBytes: 328028,
              url: '/uploads/large_default_image_a5eaa20955.png',
            },
            medium: {
              name: 'medium_default-image.png',
              hash: 'medium_default_image_a5eaa20955',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 444,
              size: 174.97,
              sizeInBytes: 174967,
              url: '/uploads/medium_default_image_a5eaa20955.png',
            },
          },
          hash: 'default_image_a5eaa20955',
          ext: '.png',
          mime: 'image/png',
          size: 81.73,
          url: '/uploads/default_image_a5eaa20955.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:40.175Z',
          updatedAt: '2025-08-18T18:14:40.175Z',
          publishedAt: '2025-08-18T18:14:40.175Z',
          locale: null,
        },
      },
      {
        id: 8,
        documentId: 'xjvk6177d27we6gdyflkwu33',
        title: 'An cư, đầu tư vững chắc tại shophouse Bách Việt Hà Nội 1',
        slug: 'an-cu-dau-tu-vung-chac-tai-shophouse-bach-viet-ha-noi',
        excerpt:
          'Dự án shophouse Bách Việt Hà Nội mang đến cơ hội đầu tư và an cư lý tưởng với vị trí đắc địa và chính sách ưu đãi hấp dẫn.',
        content:
          '<h2>Shophouse Bách Việt Hà Nội - Lựa chọn đầu tư thông minh</h2><p>Dự án shophouse Bách Việt Hà Nội được thiết kế với tiêu chuẩn cao cấp, mang đến cơ hội đầu tư và an cư lý tưởng cho các nhà đầu tư thông minh. Với vị trí đắc địa tại trung tâm thành phố, dự án hứa hẹn mang lại lợi nhuận cao và giá trị tăng trưởng bền vững.</p><h3>Điểm nổi bật của dự án</h3><ul><li><strong>Vị trí đắc địa:</strong> Nằm tại khu vực trung tâm, thuận tiện giao thông</li><li><strong>Thiết kế hiện đại:</strong> Kiến trúc tối ưu, phù hợp với xu hướng thị trường</li><li><strong>Tiện ích đầy đủ:</strong> Hệ thống tiện ích đồng bộ, đáp ứng mọi nhu cầu</li><li><strong>Tiềm năng tăng trưởng:</strong> Khu vực có tiềm năng phát triển mạnh mẽ</li></ul><h3>Chính sách ưu đãi hấp dẫn</h3><p>Bách Việt áp dụng nhiều chính sách ưu đãi đặc biệt cho khách hàng đầu tư, bao gồm:</p><ul><li>Hỗ trợ vay vốn với lãi suất ưu đãi</li><li>Chính sách ân hạn nợ gốc linh hoạt</li><li>Bảo hành chất lượng dài hạn</li><li>Dịch vụ quản lý chuyên nghiệp</li></ul><p>Đây là cơ hội đầu tư không thể bỏ qua cho những ai đang tìm kiếm một sản phẩm bất động sản chất lượng cao với tiềm năng sinh lời lớn.</p>',
        author: 'Admin',
        publishedDate: '2024-11-18T00:00:00.000Z',
        readingTime: 5,
        featured: true,
        tags: ['shophouse', 'ha-noi', 'bach-viet'],
        createdAt: '2025-08-18T18:14:40.296Z',
        updatedAt: '2025-08-18T18:14:40.296Z',
        publishedAt: '2025-08-18T18:14:40.297Z',
        locale: null,
        featuredImage: {
          id: 11,
          documentId: 'k1q47wqk6bknr9m8sdvlenbc',
          name: 'default-image.png',
          alternativeText:
            'An image uploaded to Strapi called default-image.png',
          caption: 'An image uploaded to Strapi called default-image.png',
          width: 1208,
          height: 715,
          formats: {
            thumbnail: {
              name: 'thumbnail_default-image.png',
              hash: 'thumbnail_default_image_6fe228cb86',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 145,
              size: 21.22,
              sizeInBytes: 21219,
              url: '/uploads/thumbnail_default_image_6fe228cb86.png',
            },
            small: {
              name: 'small_default-image.png',
              hash: 'small_default_image_6fe228cb86',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 296,
              size: 75.54,
              sizeInBytes: 75538,
              url: '/uploads/small_default_image_6fe228cb86.png',
            },
            large: {
              name: 'large_default-image.png',
              hash: 'large_default_image_6fe228cb86',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 592,
              size: 328.03,
              sizeInBytes: 328028,
              url: '/uploads/large_default_image_6fe228cb86.png',
            },
            medium: {
              name: 'medium_default-image.png',
              hash: 'medium_default_image_6fe228cb86',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 444,
              size: 174.97,
              sizeInBytes: 174967,
              url: '/uploads/medium_default_image_6fe228cb86.png',
            },
          },
          hash: 'default_image_6fe228cb86',
          ext: '.png',
          mime: 'image/png',
          size: 81.73,
          url: '/uploads/default_image_6fe228cb86.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:40.294Z',
          updatedAt: '2025-08-18T18:14:40.294Z',
          publishedAt: '2025-08-18T18:14:40.294Z',
          locale: null,
        },
      },
      {
        id: 10,
        documentId: 'f2f4w827jx8k7nwwaxus5t4v',
        title: 'Chính sách ân hạn nợ gốc vô thời hạn 1',
        slug: 'chinh-sach-an-han-no-goc-vo-thoi-han',
        excerpt:
          'Bách Việt triển khai chính sách ân hạn nợ gốc vô thời hạn, mang đến giải pháp tài chính linh hoạt cho khách hàng.',
        content:
          '<h2>Chính sách ân hạn nợ gốc - Giải pháp tài chính linh hoạt</h2><p>Bách Việt triển khai chính sách ân hạn nợ gốc vô thời hạn, mang đến giải pháp tài chính linh hoạt và hỗ trợ tối đa cho khách hàng trong quá trình sở hữu bất động sản.</p><h3>Đặc điểm của chính sách</h3><ul><li><strong>Ân hạn vô thời hạn:</strong> Không giới hạn thời gian ân hạn nợ gốc</li><li><strong>Linh hoạt trong thanh toán:</strong> Khách hàng có thể lựa chọn thời điểm trả nợ gốc</li><li><strong>Giảm áp lực tài chính:</strong> Chỉ cần thanh toán lãi suất trong thời gian ân hạn</li><li><strong>Phù hợp mọi đối tượng:</strong> Áp dụng cho cả khách hàng cá nhân và doanh nghiệp</li></ul><h3>Lợi ích của chính sách</h3><p>Chính sách này mang lại nhiều lợi ích thiết thực:</p><ul><li>Giúp khách hàng dễ dàng sở hữu bất động sản</li><li>Giảm áp lực tài chính trong thời gian đầu</li><li>Tạo điều kiện thuận lợi cho việc đầu tư và kinh doanh</li><li>Thể hiện cam kết hỗ trợ khách hàng của Bách Việt</li></ul><p>Với chính sách ân hạn nợ gốc vô thời hạn, Bách Việt mong muốn đồng hành cùng khách hàng trên con đường sở hữu bất động sản mơ ước.</p>',
        author: 'Admin',
        publishedDate: '2024-11-18T00:00:00.000Z',
        readingTime: 4,
        featured: true,
        tags: ['an-han-no', 'bach-viet'],
        createdAt: '2025-08-18T18:14:40.412Z',
        updatedAt: '2025-08-18T18:14:40.412Z',
        publishedAt: '2025-08-18T18:14:40.413Z',
        locale: null,
        featuredImage: {
          id: 12,
          documentId: 'amncyat46a8zk1hwnmjfmpmb',
          name: 'default-image.png',
          alternativeText:
            'An image uploaded to Strapi called default-image.png',
          caption: 'An image uploaded to Strapi called default-image.png',
          width: 1208,
          height: 715,
          formats: {
            thumbnail: {
              name: 'thumbnail_default-image.png',
              hash: 'thumbnail_default_image_56881787cb',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 145,
              size: 21.22,
              sizeInBytes: 21219,
              url: '/uploads/thumbnail_default_image_56881787cb.png',
            },
            small: {
              name: 'small_default-image.png',
              hash: 'small_default_image_56881787cb',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 296,
              size: 75.54,
              sizeInBytes: 75538,
              url: '/uploads/small_default_image_56881787cb.png',
            },
            medium: {
              name: 'medium_default-image.png',
              hash: 'medium_default_image_56881787cb',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 444,
              size: 174.97,
              sizeInBytes: 174967,
              url: '/uploads/medium_default_image_56881787cb.png',
            },
            large: {
              name: 'large_default-image.png',
              hash: 'large_default_image_56881787cb',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 592,
              size: 328.03,
              sizeInBytes: 328028,
              url: '/uploads/large_default_image_56881787cb.png',
            },
          },
          hash: 'default_image_56881787cb',
          ext: '.png',
          mime: 'image/png',
          size: 81.73,
          url: '/uploads/default_image_56881787cb.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:40.410Z',
          updatedAt: '2025-08-18T18:14:40.410Z',
          publishedAt: '2025-08-18T18:14:40.410Z',
          locale: null,
        },
      },
      {
        id: 12,
        documentId: 'v42489q9hx1vp6xcu2md3syc',
        title: 'Hạ tầng giao thông đồng bộ kích cầu thị trường BĐS Phú Yên 1',
        slug: 'ha-tang-giao-thong-dong-bo-kich-cau-thi-truong-bds-phu-yen',
        excerpt:
          'Việc phát triển hạ tầng giao thông đồng bộ tại Phú Yên đang tạo ra cơ hội mới cho thị trường bất động sản khu vực này.',
        content:
          '<h2>Phát triển hạ tầng giao thông - Động lực tăng trưởng BĐS Phú Yên</h2><p>Việc đầu tư và phát triển hạ tầng giao thông đồng bộ tại Phú Yên đang tạo ra những cơ hội mới cho thị trường bất động sản khu vực này. Các dự án giao thông trọng điểm đang được triển khai mạnh mẽ.</p><h3>Các dự án hạ tầng trọng điểm</h3><ul><li><strong>Cầu Vàm Cống:</strong> Kết nối giao thông quan trọng trong khu vực</li><li><strong>Đường cao tốc:</strong> Hệ thống đường cao tốc hiện đại</li><li><strong>Cảng biển:</strong> Phát triển cảng biển quốc tế</li><li><strong>Sân bay:</strong> Mở rộng và nâng cấp sân bay Tuy Hòa</li></ul><h3>Tác động đến thị trường BĐS</h3><p>Sự phát triển hạ tầng giao thông mang lại nhiều tác động tích cực:</p><ul><li>Tăng tính kết nối và thuận tiện di chuyển</li><li>Thúc đẩy phát triển kinh tế địa phương</li><li>Tạo cơ hội đầu tư bất động sản mới</li><li>Nâng cao giá trị bất động sản trong khu vực</li></ul><h3>Cơ hội đầu tư</h3><p>Với sự phát triển hạ tầng mạnh mẽ, Phú Yên đang trở thành điểm đến đầu tư hấp dẫn:</p><ul><li>Giá bất động sản còn thấp so với tiềm năng</li><li>Chính sách ưu đãi đầu tư của địa phương</li><li>Tiềm năng phát triển du lịch và thương mại</li><li>Môi trường sống trong lành, thiên nhiên đẹp</li></ul><p>Bách Việt đang theo dõi sát sao sự phát triển của thị trường BĐS Phú Yên và sẵn sàng đưa ra những sản phẩm phù hợp với nhu cầu thị trường.</p>',
        author: 'Admin',
        publishedDate: '2024-11-18T00:00:00.000Z',
        readingTime: 6,
        featured: true,
        tags: ['giao-thong', 'phu-yen'],
        createdAt: '2025-08-18T18:14:40.528Z',
        updatedAt: '2025-08-18T18:14:40.528Z',
        publishedAt: '2025-08-18T18:14:40.529Z',
        locale: null,
        featuredImage: {
          id: 13,
          documentId: 'sub34pmz4wmd89wrf03jbyna',
          name: 'default-image.png',
          alternativeText:
            'An image uploaded to Strapi called default-image.png',
          caption: 'An image uploaded to Strapi called default-image.png',
          width: 1208,
          height: 715,
          formats: {
            thumbnail: {
              name: 'thumbnail_default-image.png',
              hash: 'thumbnail_default_image_2bcefa68ab',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 245,
              height: 145,
              size: 21.22,
              sizeInBytes: 21219,
              url: '/uploads/thumbnail_default_image_2bcefa68ab.png',
            },
            small: {
              name: 'small_default-image.png',
              hash: 'small_default_image_2bcefa68ab',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 500,
              height: 296,
              size: 75.54,
              sizeInBytes: 75538,
              url: '/uploads/small_default_image_2bcefa68ab.png',
            },
            medium: {
              name: 'medium_default-image.png',
              hash: 'medium_default_image_2bcefa68ab',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 750,
              height: 444,
              size: 174.97,
              sizeInBytes: 174967,
              url: '/uploads/medium_default_image_2bcefa68ab.png',
            },
            large: {
              name: 'large_default-image.png',
              hash: 'large_default_image_2bcefa68ab',
              ext: '.png',
              mime: 'image/png',
              path: null,
              width: 1000,
              height: 592,
              size: 328.03,
              sizeInBytes: 328028,
              url: '/uploads/large_default_image_2bcefa68ab.png',
            },
          },
          hash: 'default_image_2bcefa68ab',
          ext: '.png',
          mime: 'image/png',
          size: 81.73,
          url: '/uploads/default_image_2bcefa68ab.png',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:40.525Z',
          updatedAt: '2025-08-18T18:14:40.525Z',
          publishedAt: '2025-08-18T18:14:40.525Z',
          locale: null,
        },
      },
    ],
  },
};
